import { ReactElement } from 'react';
import { Machine } from '../../api/graphql/generated';
import { IOCard } from './cards/io-card';
import { LogsCard } from './cards/logs-card';
import { VariablesCard } from './cards/variables-card';
import './machine.css';
interface MachineOverviewProps {
  machine?: Machine;
}

const MachineRealtime = (props: MachineOverviewProps): ReactElement => {
  const { machine } = props;

  return (
    <div className="machine-list-container">
      <div className="machine-list-spacing">
        <VariablesCard machine={machine} />
      </div>
      <div className="machine-list-spacing">
        <IOCard machine={machine} />
      </div>
      <div className="machine-list-spacing">
        <LogsCard machine={machine} />
      </div>
    </div>
  );
};

export { MachineRealtime };
